import { render, staticRenderFns } from "./TooltipHeading.vue?vue&type=template&id=345f067a&scoped=true&"
import script from "./TooltipHeading.vue?vue&type=script&lang=ts&"
export * from "./TooltipHeading.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipHeading.vue?vue&type=style&index=0&id=345f067a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f067a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
